"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
require("./tree-node-renderer.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FileThemeTreeNodeRenderer'), (0, recompose_1.defaultProps)({
    swapFrom: null,
    swapDepth: null,
    swapLength: null,
    canDrop: false,
    draggedNode: null
}), recompose_1.pure);
var FileThemeTreeNodeRenderer = function (outerProps) {
    return enhance(function (props) {
        return props.connectDropTarget(React.createElement("div", { onDragEnter: props.onDragEnter, onDrop: props.onDrop, onDragOver: props.onDragOver, className: 'sok-folder-tree-node' }, React.Children.map(props.children, function (child) {
            return React.cloneElement(child, {
                isOver: props.isOver,
                canDrop: props.canDrop,
                draggedNode: props.draggedNode,
                lowerSiblingCounts: props.lowerSiblingCounts,
                listIndex: props.listIndex,
                swapFrom: props.swapFrom,
                swapLength: props.swapLength,
                swapDepth: props.swapDepth
            });
        })));
    });
};
exports.default = FileThemeTreeNodeRenderer;
